import React from 'react'
import styles from './index.module.scss'
import { SecondaryButton } from '../button'
import { handleRegistrationScroll } from '../../../../utils/helper'


const HeroSection = () => {
    return (
        <section className={styles.hero_section}>
            <div className={styles.hero_container}>
                <div className={styles.hero_content}>
                    <h2 className={styles.hero_heading}>University Bible Fellowship (UBF)</h2>
                    <p className={styles.hero_text}>Presents</p>
                    <h3>Easter bible conference 2026: </h3>
                    <h1>
                    The Vision <br/> Isaiah 6:8 </h1>
                    <SecondaryButton className={styles.hero_btn} onClick={handleRegistrationScroll}>Register Now</SecondaryButton>
                </div>
            </div>
        </section>
    )
}

export default HeroSection
